import * as $ from 'jquery';

const settings = {
	addressSelectContainer: '.js-address-select-container',
	addressManualContainer: '.js-address-manual-container',
	postcodeInput: '.js-lookup-postcode',
	lookupButton: '.js-lookup-address',
	addressSelect: '.js-address-select',
	addressFields: '.js-lookup-address-field',
	addressLine1Input: '.js-lookup-address-line-1',
	addressLine2Input: '.js-lookup-address-line-2',
	cityInput: '.js-lookup-address-city',
	countyInput: '.js-lookup-address-county',
	countryInput: '.js-lookup-address-country',
	token: 'meta[name=address_lookup_token]',
	manualAddressButton: '.js-manual-address',
	manualAddressButtonContainer: '.js-manual-address-button-container',
	addressLookupError: '.js-address-lookup-error'
};

var token;

export const init = () => {
	token = $(settings.token).attr('content');
	$(settings.addressLookupError).hide();

	const $addressLine1 = $(settings.addressLine1Input);
	if (!$addressLine1.val() && !$addressLine1.data('has-error')) {
		// If this field is empty and has no validation errors hide the full address entry
		$(settings.addressManualContainer).hide();
		$(settings.manualAddressButtonContainer).show();
	}

	$(settings.lookupButton).on('click', (event) => {
		event.preventDefault();
		const postcode = $(settings.postcodeInput).val();
		const country = $(settings.countryInput).val();
		populateAddresses(postcode, country);
	});

	$(settings.addressSelect).on('change', function (event) {
		const addressId = this.value;
		populateAddressFields(addressId);
	});

	$(settings.manualAddressButton).on('click', (event) => {
		event.preventDefault();
		$(settings.addressLookupError).hide();
		$(settings.addressSelectContainer).hide();
		$(settings.addressManualContainer).show();
		$(settings.manualAddressButtonContainer).hide();
	});
}

function populateAddresses(postcode, country) {
	const $addressSelect = $(settings.addressSelect);
	const $addressSelectContainer = $(settings.addressSelectContainer);

	$(settings.addressManualContainer).hide();
	$(settings.addressLookupError).hide();
	$(settings.addressSelectContainer).hide();
	$(settings.manualAddressButtonContainer).show();

	// Clear out the address fields
	$addressSelect.empty();
	$(settings.addressFields).val('');
	$addressSelect.append('<option value="">Please Select…</option>');

	// Get the options for this postcode
	$.ajax('/ajax/address_lookup/search', {
		data: {
			search: postcode,
			country: country,
			token: token
		},
		success: (response) => {
			const data = JSON.parse(response);

			for (const key in data.results) {
				const address = data.results[key];
				$addressSelect.append('<option value="' + address.id + '">' + address.label + '</option>');
			}

			$addressSelectContainer.show();
		},
		error: (xhr, status, error) => {
			$(settings.addressManualContainer).show();
			$(settings.addressLookupError).show();
			$(settings.manualAddressButtonContainer).hide();
		}
	});
}

function populateAddressFields(id) {
	// Clear any old data
	$(settings.addressFields).val('');
	$(settings.addressSelect).attr('disabled', true);
	$(settings.addressLookupError).hide();

	// Fill the fields with the new data
	$.ajax('/ajax/address_lookup/address', {
		data: {
			id,
			token
		},
		success: (response) => {
			const data = JSON.parse(response);
			$(settings.addressLine1Input).val(data.result.address_line_1);
			$(settings.addressLine2Input).val(data.result.address_line_2);
			$(settings.cityInput).val(data.result.city);
			$(settings.countyInput).val(data.result.county);
			$(settings.postcodeInput).val(data.result.postcode);

			$(settings.addressSelectContainer).hide();
			$(settings.addressManualContainer).show();
			$(settings.addressSelect).attr('disabled', false);
		},
		error: (xhr, status, error) => {
			$(settings.addressLookupError).show();
			$(settings.addressSelectContainer).hide();
			$(settings.addressManualContainer).show();
			$(settings.addressSelect).attr('disabled', false);
			$(settings.manualAddressButtonContainer).hide();
		}
	});

}

init();


